export const NODE_EDGE_WIDTH = 10;
export const DRAG_THRESHOLD = 10;
